<template>
  <g>
    <path :d="'M' + A.x + ' ' + A.y + ' L' + B.x + ' ' + B.y + ' L' + C.x + ' ' + C.y + ' L' + D.x + ' ' + D.y + ' L' + E.x + ' ' + E.y + ' L' + F.x + ' ' + F.y + ' L' + G.x + ' ' + G.y + 'Z'" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <g v-for="(side, index) in sides" :key="index">
        <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
      </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === rand.saum.titleSaum.name">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="activeOesenArt">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === rand.hohlsaum.title.name" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
      </g>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt,
      A: {
        x: 170,
        y: 425
      },
      B: {
        x: 170 - 160 * this.sinCalc(90 * 3 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7)
      },
      C: {
        x: 170 - 160 * this.sinCalc(90 * 3 / 7) + 160 * this.sinCalc(90 * 1 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7) - 160 * this.sinCalc(180 * 3 / 7)
      },
      D: {
        x: 170 - 160 * this.sinCalc(90 * 3 / 7) + 160 * this.sinCalc(90 * 1 / 7) + 160 * this.sinCalc(180 * 5 / 14),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7) - 160 * this.sinCalc(180 * 3 / 7) - 160 * this.sinCalc(90 * 2 / 7)
      },
      E: {
        x: 330 + 160 * this.sinCalc(90 * 3 / 7) - 160 * this.sinCalc(90 * 1 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7) - 160 * this.sinCalc(180 * 3 / 7)
      },
      F: {
        x: 330 + 160 * this.sinCalc(90 * 3 / 7),
        y: 425 - 160 * this.sinCalc(180 * 2 / 7)
      },
      G: {
        x: 330,
        y: 425
      }
    }
  },
  methods: {
    sinCalc (alpha) {
      return Math.sin(alpha * Math.PI / 180)
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            xEnd: this.G.x - 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            yConst: this.A.y - 15,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return this.yConst
            }
          },
          saum: 'M' + (this.A.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.A.y - 30) + ' L' + (this.G.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.G.y - 30),
          hohlsaum: 'M' + (this.A.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.A.y - 9) + ' L' + (this.G.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.G.y - 9),
          labelSpace: {
            x: 250,
            y: 452
          },
          labelBackground: {
            x: 215,
            y: 435,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.A.x,
              yStart: this.A.y + 40,
              xEnd: this.G.x,
              yEnd: this.G.y + 40
            },
            corner: {
              start: this.A.x + ',' + (this.A.y + 40) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 35) + ' ' + (this.A.x + 10) + ',' + (this.A.y + 45),
              rotateStart: 'rotate(0, ' + this.A.x + ', ' + (this.A.y + 40) + ')',
              end: this.G.x + ',' + (this.G.y + 40) + ' ' + (this.G.x - 10) + ',' + (this.G.y + 35) + ' ' + (this.G.x - 10) + ',' + (this.G.y + 45),
              rotateEnd: 'rotate(0, ' + this.G.x + ', ' + (this.G.y + 40) + ')'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            xStart: this.A.x + 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            xEnd: this.B.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            yStart: this.A.y - 15,
            yEnd: this.B.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.A.x + 30 / this.sinCalc(2 / 7 * 180)) + ' ' + this.A.y + ' L' + (this.B.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.B.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          hohlsaum: 'M' + (this.A.x + 9 / this.sinCalc(2 / 7 * 180)) + ' ' + this.A.y + ' L' + (this.B.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.B.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          labelSpace: {
            x: 75,
            y: 377
          },
          labelBackground: {
            x: 40,
            y: 360,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.A.x - this.sinCalc(2 / 7 * 180) * 40,
              yStart: this.A.y + this.sinCalc(3 / 14 * 180) * 40,
              xEnd: this.B.x - this.sinCalc(2 / 7 * 180) * 40,
              yEnd: this.B.y + this.sinCalc(3 / 14 * 180) * 40
            },
            corner: {
              start: (this.A.x - this.sinCalc(2 / 7 * 180) * 40) + ',' + (this.A.y + this.sinCalc(3 / 14 * 180) * 40) + ' ' + ((this.A.x - this.sinCalc(2 / 7 * 180) * 40) + 5) + ',' + (this.A.y + this.sinCalc(3 / 14 * 180) * 40 - 10) + ' ' + ((this.A.x - this.sinCalc(2 / 7 * 180) * 40) - 5) + ',' + (this.A.y + this.sinCalc(3 / 14 * 180) * 40 - 10),
              rotateStart: 'rotate(' + ((-3) / 14 * 180) + ', ' + (this.A.x - this.sinCalc(2 / 7 * 180) * 40) + ', ' + (this.A.y + this.sinCalc(3 / 14 * 180) * 40) + ')',
              end: (this.B.x - this.sinCalc(2 / 7 * 180) * 40) + ',' + (this.B.y + this.sinCalc(3 / 14 * 180) * 40) + ' ' + ((this.B.x - this.sinCalc(2 / 7 * 180) * 40) + 5) + ',' + (this.B.y + this.sinCalc(3 / 14 * 180) * 40 + 10) + ' ' + ((this.B.x - this.sinCalc(2 / 7 * 180) * 40) - 5) + ',' + (this.B.y + this.sinCalc(3 / 14 * 180) * 40 + 10),
              rotateEnd: 'rotate(' + ((-3) / 14 * 180) + ', ' + (this.B.x - this.sinCalc(2 / 7 * 180) * 40) + ', ' + (this.B.y + this.sinCalc(3 / 14 * 180) * 40) + ')'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          size: Math.round(this.calcSides[2]),
          rand: this.randSides[2].type.name,
          oesenAnzahl: this.randSides[2].oesenAnzahl,
          oesenAbstand: {
            xStart: this.B.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            xEnd: this.C.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            yStart: this.B.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            yEnd: this.C.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.B.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.B.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.C.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.C.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.B.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.B.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.C.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.C.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 40,
            y: 200
          },
          labelBackground: {
            x: 5,
            y: 185,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.B.x - this.sinCalc(6 / 14 * 180) * 40,
              yStart: this.B.y - this.sinCalc(1 / 14 * 180) * 40,
              xEnd: this.C.x - this.sinCalc(6 / 14 * 180) * 40,
              yEnd: this.C.y - this.sinCalc(1 / 14 * 180) * 40
            },
            corner: {
              start: (this.B.x - this.sinCalc(6 / 14 * 180) * 40) + ',' + (this.B.y - this.sinCalc(1 / 14 * 180) * 40) + ' ' + (this.B.x - this.sinCalc(6 / 14 * 180) * 40 + 5) + ',' + (this.B.y - this.sinCalc(1 / 14 * 180) * 40 - 10) + ' ' + (this.B.x - this.sinCalc(6 / 14 * 180) * 40 - 5) + ',' + (this.B.y - this.sinCalc(1 / 14 * 180) * 40 - 10),
              rotateStart: 'rotate(' + (1 / 14 * 180) + ', ' + (this.B.x - this.sinCalc(6 / 14 * 180) * 40) + ', ' + (this.B.y - this.sinCalc(1 / 14 * 180) * 40) + ')',
              end: (this.C.x - this.sinCalc(6 / 14 * 180) * 40) + ',' + (this.C.y - this.sinCalc(1 / 14 * 180) * 40) + ' ' + (this.C.x - this.sinCalc(6 / 14 * 180) * 40 + 5) + ',' + (this.C.y - this.sinCalc(1 / 14 * 180) * 40 + 10) + ' ' + (this.C.x - this.sinCalc(6 / 14 * 180) * 40 - 5) + ',' + (this.C.y - this.sinCalc(1 / 14 * 180) * 40 + 10),
              rotateEnd: 'rotate(' + (1 / 14 * 180) + ', ' + (this.C.x - this.sinCalc(6 / 14 * 180) * 40) + ', ' + (this.C.y - this.sinCalc(1 / 14 * 180) * 40) + ')'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          size: Math.round(this.calcSides[3]),
          rand: this.randSides[3].type.name,
          oesenAnzahl: this.randSides[3].oesenAnzahl,
          oesenAbstand: {
            xStart: this.C.x + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            xEnd: this.D.x,
            yStart: this.C.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            yEnd: this.D.y + 15 / this.sinCalc(5 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.C.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.C.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.C.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.C.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 155,
            y: 50
          },
          labelBackground: {
            x: 120,
            y: 30,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.C.x - this.sinCalc(1 / 7 * 180) * 40,
              yStart: this.C.y - this.sinCalc(5 / 14 * 180) * 40,
              xEnd: this.D.x - this.sinCalc(1 / 7 * 180) * 40,
              yEnd: this.D.y - this.sinCalc(5 / 14 * 180) * 40
            },
            corner: {
              start: (this.C.x - this.sinCalc(1 / 7 * 180) * 40) + ',' + (this.C.y - this.sinCalc(5 / 14 * 180) * 40) + ' ' + (this.C.x - this.sinCalc(1 / 7 * 180) * 40 + 10) + ',' + (this.C.y - this.sinCalc(5 / 14 * 180) * 40 + 5) + ' ' + (this.C.x - this.sinCalc(1 / 7 * 180) * 40 + 10) + ',' + (this.C.y - this.sinCalc(5 / 14 * 180) * 40 - 5),
              rotateStart: 'rotate(' + ((-1) / 7 * 180) + ', ' + (this.C.x - this.sinCalc(1 / 7 * 180) * 40) + ', ' + (this.C.y - this.sinCalc(5 / 14 * 180) * 40) + ')',
              end: (this.D.x - this.sinCalc(1 / 7 * 180) * 40) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40) + ' ' + (this.D.x - this.sinCalc(1 / 7 * 180) * 40 - 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40 + 5) + ' ' + (this.D.x - this.sinCalc(1 / 7 * 180) * 40 - 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40 - 5),
              rotateEnd: 'rotate(' + ((-1) / 7 * 180) + ', ' + (this.D.x - this.sinCalc(1 / 7 * 180) * 40) + ', ' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40) + ')'
            }
          },
          id: 4
        },
        e: {
          name: 'e',
          size: Math.round(this.calcSides[4]),
          rand: this.randSides[4].type.name,
          oesenAnzahl: this.randSides[4].oesenAnzahl,
          oesenAbstand: {
            xStart: this.E.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            xEnd: this.D.x,
            yStart: this.E.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            yEnd: this.D.y + 15 / this.sinCalc(5 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.E.x + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.E.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.E.x + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.E.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)) + ' L' + (this.D.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.D.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 345,
            y: 50
          },
          labelBackground: {
            x: 310,
            y: 30,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.D.x + this.sinCalc(1 / 7 * 180) * 40,
              yStart: this.D.y - this.sinCalc(5 / 14 * 180) * 40,
              xEnd: this.E.x + this.sinCalc(1 / 7 * 180) * 40,
              yEnd: this.E.y - this.sinCalc(5 / 14 * 180) * 40
            },
            corner: {
              start: (this.D.x + this.sinCalc(1 / 7 * 180) * 40) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40) + ' ' + (this.D.x + this.sinCalc(1 / 7 * 180) * 40 + 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40 + 5) + ' ' + (this.D.x + this.sinCalc(1 / 7 * 180) * 40 + 10) + ',' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40 - 5),
              rotateStart: 'rotate(' + (1 / 7 * 180) + ', ' + (this.D.x + this.sinCalc(1 / 7 * 180) * 40) + ', ' + (this.D.y - this.sinCalc(5 / 14 * 180) * 40) + ')',
              end: (this.E.x + this.sinCalc(1 / 7 * 180) * 40) + ',' + (this.E.y - this.sinCalc(5 / 14 * 180) * 40) + ' ' + (this.E.x + this.sinCalc(1 / 7 * 180) * 40 - 10) + ',' + (this.E.y - this.sinCalc(5 / 14 * 180) * 40 + 5) + ' ' + (this.E.x + this.sinCalc(1 / 7 * 180) * 40 - 10) + ',' + (this.E.y - this.sinCalc(5 / 14 * 180) * 40 - 5),
              rotateEnd: 'rotate(' + (1 / 7 * 180) + ', ' + (this.E.x + this.sinCalc(1 / 7 * 180) * 40) + ', ' + (this.E.y - this.sinCalc(5 / 14 * 180) * 40) + ')'
            }
          },
          id: 5
        },
        f: {
          name: 'f',
          size: Math.round(this.calcSides[5]),
          rand: this.randSides[5].type.name,
          oesenAnzahl: this.randSides[5].oesenAnzahl,
          oesenAbstand: {
            xStart: this.F.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            xEnd: this.E.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(2 / 7 * 180),
            yStart: this.F.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            yEnd: this.E.y + 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.F.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.F.y + 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.E.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.E.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          hohlsaum: 'M' + (this.F.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 14 * 180)) + ' ' + (this.F.y + 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(2 / 7 * 180)) + ' L' + (this.E.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(5 / 14 * 180)) + ' ' + (this.E.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 7 * 180)),
          labelSpace: {
            x: 460,
            y: 200
          },
          labelBackground: {
            x: 425,
            y: 185,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.E.x + this.sinCalc(6 / 14 * 180) * 40,
              yStart: this.E.y - this.sinCalc(1 / 14 * 180) * 40,
              xEnd: this.F.x + this.sinCalc(6 / 14 * 180) * 40,
              yEnd: this.F.y - this.sinCalc(1 / 14 * 180) * 40
            },
            corner: {
              start: (this.E.x + this.sinCalc(6 / 14 * 180) * 40) + ',' + (this.E.y - this.sinCalc(1 / 14 * 180) * 40) + ' ' + (this.E.x + this.sinCalc(6 / 14 * 180) * 40 + 5) + ',' + (this.E.y - this.sinCalc(1 / 14 * 180) * 40 + 10) + ' ' + (this.E.x + this.sinCalc(6 / 14 * 180) * 40 - 5) + ',' + (this.E.y - this.sinCalc(1 / 14 * 180) * 40 + 10),
              rotateStart: 'rotate(' + ((-1) / 14 * 180) + ', ' + (this.E.x + this.sinCalc(6 / 14 * 180) * 40) + ', ' + (this.E.y - this.sinCalc(1 / 14 * 180) * 40) + ')',
              end: (this.F.x + this.sinCalc(6 / 14 * 180) * 40) + ',' + (this.F.y - this.sinCalc(1 / 14 * 180) * 40) + ' ' + (this.F.x + this.sinCalc(6 / 14 * 180) * 40 + 5) + ',' + (this.F.y - this.sinCalc(1 / 14 * 180) * 40 - 10) + ' ' + (this.F.x + this.sinCalc(6 / 14 * 180) * 40 - 5) + ',' + (this.F.y - this.sinCalc(1 / 14 * 180) * 40 - 10),
              rotateEnd: 'rotate(' + ((-1) / 14 * 180) + ', ' + (this.F.x + this.sinCalc(6 / 14 * 180) * 40) + ', ' + (this.F.y - this.sinCalc(1 / 14 * 180) * 40) + ')'
            }
          },
          id: 6
        },
        g: {
          name: 'g',
          size: Math.round(this.calcSides[6]),
          rand: this.randSides[6].type.name,
          oesenAnzahl: this.randSides[6].oesenAnzahl,
          oesenAbstand: {
            xStart: this.G.x - 15 * this.sinCalc(1 / 7 * 180) / this.sinCalc(5 / 14 * 180),
            xEnd: this.F.x - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(3 / 7 * 180),
            yStart: this.G.y - 15,
            yEnd: this.F.y - 15 / this.sinCalc(5 / 14 * 180) * this.sinCalc(1 / 14 * 180),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (this.G.x - 30 / this.sinCalc(2 / 7 * 180)) + ' ' + this.G.y + ' L' + (this.F.x - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.F.y - 30 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          hohlsaum: 'M' + (this.G.x - 9 / this.sinCalc(2 / 7 * 180)) + ' ' + this.G.y + ' L' + (this.F.x - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(1 / 14 * 180)) + ' ' + (this.F.y - 9 / this.sinCalc(2 / 7 * 180) * this.sinCalc(3 / 7 * 180)),
          labelSpace: {
            x: 425,
            y: 377
          },
          labelBackground: {
            x: 390,
            y: 360,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: this.G.x + this.sinCalc(2 / 7 * 180) * 40,
              yStart: this.G.y + this.sinCalc(3 / 14 * 180) * 40,
              xEnd: this.F.x + this.sinCalc(2 / 7 * 180) * 40,
              yEnd: this.F.y + this.sinCalc(3 / 14 * 180) * 40
            },
            corner: {
              start: (this.G.x + this.sinCalc(2 / 7 * 180) * 40) + ',' + (this.G.y + this.sinCalc(3 / 14 * 180) * 40) + ' ' + ((this.G.x + this.sinCalc(2 / 7 * 180) * 40) + 5) + ',' + (this.G.y + this.sinCalc(3 / 14 * 180) * 40 - 10) + ' ' + ((this.G.x + this.sinCalc(2 / 7 * 180) * 40) - 5) + ',' + (this.G.y + this.sinCalc(3 / 14 * 180) * 40 - 10),
              rotateStart: 'rotate(' + (3 / 14 * 180) + ', ' + (this.G.x + this.sinCalc(2 / 7 * 180) * 40) + ', ' + (this.G.y + this.sinCalc(3 / 14 * 180) * 40) + ')',
              end: (this.F.x + this.sinCalc(2 / 7 * 180) * 40) + ',' + (this.F.y + this.sinCalc(3 / 14 * 180) * 40) + ' ' + ((this.F.x + this.sinCalc(2 / 7 * 180) * 40) + 5) + ',' + (this.F.y + this.sinCalc(3 / 14 * 180) * 40 + 10) + ' ' + ((this.F.x + this.sinCalc(2 / 7 * 180) * 40) - 5) + ',' + (this.F.y + this.sinCalc(3 / 14 * 180) * 40 + 10),
              rotateEnd: 'rotate(' + (3 / 14 * 180) + ', ' + (this.F.x + this.sinCalc(2 / 7 * 180) * 40) + ', ' + (this.F.y + this.sinCalc(3 / 14 * 180) * 40) + ')'
            }
          },
          id: 7
        }
      }
    }
  }
}
</script>

<style>
</style>
